import { clsx } from 'clsx'
import { useLayoutVariant } from '../../hooks/useLayoutVariant'

export default function Card({ children, className = '', hover = false, glow = false, ...props }) {
  const { isAdminAppUI } = useLayoutVariant()

  return (
    <div className={clsx(
      isAdminAppUI
        ? 'bg-[#1a2535] rounded-[14px] border border-[#243246] shadow-none transition-all duration-200'
        : 'bg-white dark:bg-slate-700 rounded-3xl border border-pastel-pink/80 dark:border-slate-500 shadow-soft transition-all duration-300',
      'animate-fade-in-up',
      hover && (isAdminAppUI
        ? 'hover:border-[#00c896] hover:-translate-y-0.5 cursor-pointer'
        : 'hover:shadow-medium hover:border-pastel-lavender dark:hover:border-slate-400 hover:-translate-y-0.5 cursor-pointer'),
      glow && 'relative overflow-hidden',
      className
    )} {...props}>
      {glow && (
        <div className={clsx(
          'absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-300 pointer-events-none',
          isAdminAppUI
            ? 'bg-[rgba(0,200,150,0.05)]'
            : 'bg-gradient-to-br from-pastel-teal/20 to-transparent dark:from-teal-900/20'
        )} />
      )}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  )
}

export function CardHeader({ children, className = '' }) {
  const { isAdminAppUI } = useLayoutVariant()
  return (
    <div className={clsx(
      isAdminAppUI
        ? 'px-4 sm:px-5 py-4 border-b border-[#243246]'
        : 'px-4 sm:px-6 py-4 sm:py-5 border-b border-pastel-pink dark:border-gray-700',
      className
    )}>
      {children}
    </div>
  )
}

export function CardContent({ children, className = '' }) {
  const { isAdminAppUI } = useLayoutVariant()
  return (
    <div className={clsx(isAdminAppUI ? 'px-4 sm:px-5 py-4' : 'px-4 sm:px-6 py-3 sm:py-4', className)}>
      {children}
    </div>
  )
}

export function CardFooter({ children, className = '' }) {
  const { isAdminAppUI } = useLayoutVariant()
  return (
    <div className={clsx(
      isAdminAppUI
        ? 'px-4 sm:px-5 py-4 border-t border-[#243246]'
        : 'px-4 sm:px-6 py-4 sm:py-5 border-t border-pastel-pink dark:border-slate-500',
      className
    )}>
      {children}
    </div>
  )
}
